import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_URL } from '@/config/amIntelligence';

const ProductenTeaser: React.FC = () => {
  return (
    <section className="section bg-brand-lightBlue">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-brand-intel font-bold tracking-wider text-sm mb-4 uppercase">
              AM Intelligence
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
              De marktkennis achter onze resultaten.
            </h2>
            <p className="text-lg text-gray-700">
              Elke campagne van Afsprakenmaker draait op AM Intelligence: 2 miljoen Belgische bedrijfsprofielen, financiële scores en gesprekssignalen uit de praktijk.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
            <Link
              to="/producten"
              className="inline-flex items-center justify-center px-5 py-3 rounded-md font-medium bg-brand-red text-white hover:bg-brand-darkRed transition-colors"
            >
              Ontdek AM Intelligence
            </Link>
            <a
              href={CONTACT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-5 py-3 rounded-md font-medium border border-brand-intel text-brand-intel hover:bg-brand-intel hover:text-white transition-colors"
            >
              Plan een kennismaking
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductenTeaser;
